import {SmetioAjax} from 
    "./../../../../classes/smetioAjax/SmetioAjax.js";

import {globalVar} from 
    "./../../../../variables/global_variables.js";

import {all_leftSideMenu_is_loaded} from 
    "./all_leftSideMenu_is_loaded.js";
        
    

export function getLeftSideMenuItems(){

    const smetioAjax = new SmetioAjax();

    const preloader = smetioAjax.preloader.render();

    const setupObj = {
    
        url_of_data: globalVar.smetio_retrieveData_url+"getLeftSideMenuItems/",
                                
        allDataRetrievedFunction: all_leftSideMenu_is_loaded,
        
        errorExtraText: "Try again by clicking on the menu bar",
        errorContainer: "#smetio-app-ui-body-section-1",
    
    };    
    
    

      
    /**** 
    
        USE THE dataToSendToServer TO TELL THE SERVER THE LIMIT AND OFFSET OF THE SELECTION
    
    ****/
    
    smetioAjax.dataToSendToServer =  {
    
        language: globalVar.selected_language,
        app_in_use: globalVar.app_in_use
    
    };
    
    smetioAjax.urlToConnectTo = setupObj.url_of_data;
        
    smetioAjax.beforeSend = () => {
               
        $(setupObj.errorContainer+" .ajaxErrorMsg").remove();
        
        globalVar.allLeftSideMenuItemsAreLoaded = true;
        
        $(setupObj.errorContainer).append(preloader);
                             
    };
    
    
    smetioAjax.success = (result) => {
        
        setupObj.allDataRetrievedFunction(result);
                
        return false;
                        
    };    


    smetioAjax.error = (request, status, error) => {
    
        globalVar.allLeftSideMenuItemsAreLoaded = false;
        
        smetioAjax.defaultErrorMsg +=`<h5>${ setupObj.errorExtraText } </h5>`;
        
        smetioAjax.showErrorMessage(setupObj.errorContainer);
                
        return false;
            
    };
    
    smetioAjax.sendRequest();
    
};
